<template>


  <div class="container">
    <div class="row">
      <div class="col-12 col-sm-6 col-md-5 mx-auto text-center">
        <div class="login_container">
          <div class="mb-3">
            <img alt="logo" class="logo" src="../../assets/img/logo.jpg">
          </div>
          <transition name="fade" mode="out-in">
            <form key="1" v-if="state === 1" name="login" @submit.prevent="mobileSubmit">
              <h4 class="my-3">ورود با موبایل</h4>
              <div class="form-group">
                <fvSelect class="form-control text-right fv-size-md"
                          placeholder="کد کشور"
                          v-model="country_code"
                          text-key="name" value-key="dCode"

                          :options="country_option">

                  <template slot="value" slot-scope="scope">
                    {{scope.option.name}} (+{{scope.option.dCode}})
                  </template>

                </fvSelect>

              </div>
              <div class="form-group input-group">
                <fg-input v-model="item.mobile" placeholder="شماره موبایل"
                          addon-right-icon="fas fa-mobile-alt icon font-25 no_border no_border">
                </fg-input>
              </div>

              <p-button type="success" class="w-100 mb-3" nativeType="submit">ادامه</p-button>
              <div class="row">
                <div class="col-12 col-md-6 mt-2 w-100 text-right">
                  <a @click.prevent="state = 2">
                    ورود با نام کاربری
                  </a>
                </div>
              </div>

            </form>
            <form key="2" v-else-if="state === 2" name="login" @submit.prevent="userNameSubmit">
              <h4 class="my-3">ورود با نام کاربری</h4>

              <div class="form-group input-group">
                <fg-input v-model="item.mobile" placeholder="نام کاربری"
                          addon-right-icon="fas fa-user icon font-25 no_border no_border">
                </fg-input>
                <fg-input v-model="item.mobile" placeholder="رمز عبور"
                          addon-right-icon="fas fa-lock icon font-25 no_border no_border">
                </fg-input>
              </div>

              <p-button type="success" class="w-100 mb-3" nativeType="submit">ورود</p-button>
              <div class="row">
                <div class="col-12 col-md-6 mt-2 w-100 text-right">
                  <a @click.prevent="state = 1">
                    ورود با موبایل
                  </a>
                </div>
                <div class="col-12 col-md-6 font-12 mt-2 w-100 text-left">
                  <router-link :to="{ name: 'dashboard' }">
                    رمز عبور خودرا فراموش کرده اید؟
                  </router-link>
                </div>

              </div>

            </form>
            <form key="3" v-else-if="state === 3" name="login2" @submit.prevent="smsCodeSubmit">
              <div class="form-group input-group">
                <fg-input v-model="item.code" placeholder="کد تایید"
                          addon-right-icon="fas fa-user-check icon font-25 no_border no_border">
                </fg-input>
              </div>

              <p-button type="success" class="w-100 mb-3" nativeType="submit">ورود</p-button>
            </form>
          </transition>

        </div>
      </div>
    </div>
  </div>


</template>

<script>

  const countryCode = require("../../../static/country.json")
  import {mapActions} from 'vuex'

  export default {
    components: {},
    mounted() {
    },
    data() {

      return {
        item: {},
        state: 1,
        country_option: countryCode,
        country_code: "98",
        ...mapActions('main', [
          'crud',
          'setAuthTokens'
        ]),
      }

    },
    methods: {

      async mobileSubmit() {
        const mobile = `(${this.country_code})${this.item.mobile}`
        try {
          const result = await this.crud({
            action: 'post',
            section: 'auth/otp',
            data: {mobile: mobile},
          })
          if (result.status === 204)
            this.state = 3

        } catch (e) {
          // console.log(e)
        }

      },
      async userNameSubmit() {
        // const mobile = `(${this.country_code})${this.item.mobile}`
        // try {
        //   const result = await this.crud({
        //     action: 'post',
        //     section: 'auth/otp',
        //     data: {mobile: mobile},
        //   })
        //   if (result)
        //     this.state = 2
        //
        // } catch (e) {
        //   console.log(e.response)
        // }
        this.state = 3

      },
      async smsCodeSubmit() {
        const mobile = `(${this.country_code})${this.item.mobile}`
        try {
          const result = await this.crud({
            action: 'post',
            section: 'auth/otp/verify',
            data: {mobile: mobile, code: this.item.code},
          })
          const data = result.data
          await this.setAuthTokens({
            accessToken: data.access_token,
            refreshToken: data.refresh_token,
            expireIn: data.expires_in
          })

        } catch (e) {
          // console.log(e.response)
        }

      }
    }
  };
</script>
<style lang="scss">
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .5s
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0
  }

</style>
